import { useCompanyConfigContext } from "@/context/CompanyConfigContext";

export const CompanyLogo = (
  props: React.ImgHTMLAttributes<HTMLImageElement>,
) => {
  const { settings } = useCompanyConfigContext();

  return <img src={settings?.logo} alt={settings?.name} {...props} />;
};
